
const dateFormat = require('bmh/date-format');
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const getUrl = require('baimahu/url-with-param');
const { VUE_APP_FCAPI: FCAPI } = process.env;

function validateMapFormat() {
  return {
    id: {
      value: '',
      status: '',
      help: ''
    },
    weixin_nickname: {
      value: '',
      status: '',
      help: ''
    },
    weixin_number: {
      value: '',
      status: '',
      help: ''
    },
    mobile: {
      value: '',
      status: '',
      help: ''
    },
    charge: {
      value: '',
      status: '',
      help: ''
    },
    status: {
      value: 1,
      status: '',
      help: ''
    }
  };
}

enum enumMergeDialog {
  choose_company,
  confirm_data
}

const API = {
  get_list: `${FCAPI}/boss/hundun/company/follower`,
  edit_follower: `${FCAPI}/boss/hundun/company/follower`,
  post_merge: `${FCAPI}/boss/hundun/company/merge`
};

const employees_table: any = {
  '0': {
    employees_number_floor: 0,
    employees_number_ceil: 50
  },
  '1': {
    employees_number_floor: 51,
    employees_number_ceil: 100
  },
  '2': {
    employees_number_floor: 101,
    employees_number_ceil: 500
  },
  '3': {
    employees_number_floor: 501,
    employees_number_ceil: ''
  }
};

function initForm() {
  return {
    current: 1,
    limit: 20,
    weixin_nickname: '',
    mobile: '',
    charge: '',
    status: 0
  };
}

// function initMergeFrom() {
//   return {
//     full_name: '',
//     location: '',
//     industry: '',
//   }
// }

@Component
export default class CompanyList extends Vue {
  form_merge_company: any;
  more_change_form: any;
  form = initForm();
  merge_from = initForm();
  employees_id = '';
  is_loading = false;
  locale = zhCN;
  table_data: any = {};
  table_data_merge: any = {};
  select_row_data = []; //已选择的具体数据
  merge_select_row_data = []; //已选择的具体数据
  merge_select_row_key = [];
  more_change = [
    {
      id: 1,
      value: '跟进状态'
    },
    {
      id: 2,
      value: '目前跟进人'
    }
  ];
  show_add_tag = false; // 添加标签弹框
  more_id = -1; //批量修改类型选择www
  merge_dialog = false;
  enumMergeDialog = enumMergeDialog;
  merge_dialog_type = enumMergeDialog.choose_company;
  validate_map: any = validateMapFormat();
  follower_modal = false;
  is_edit = false;

  // 批量修改弹框
  addFollower() {
    // if (this.select_row_data.length === 0) {
    //   this.$message.error('请先勾选要批量修改的用户');
    //   return;
    // }
    // this.button_type = 3;
    this.is_edit = false;
    this.validate_map = validateMapFormat();
    this.follower_modal = true;
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }

  async search(page = 1) {
    // this.form_merge_company.resetFields(['full_name', 'standard']);
    console.log(page);
    this.init(page);
    console.log(this.form);
  }

  //翻页
  changePage(page: any) {
    this.init(page.current);
  }

  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }

  handleClear() {
    this.form = initForm();
    // this.init(1);
  }

  handleClearMerge() {
    this.merge_from = initForm();
    // this.initMerge(1);
  }

  changeMoretype(id: number) {
    this.form_merge_company.resetFields(['full_name', 'standard']);
    this.more_id = id;
  }

  async init(page = 1) {
    const url = getUrl(API.get_list, { ...this.form, current: page });
    const res: any = await this.$axios.get(url);
    this.table_data = res.data.data ? res.data.data : [];
  }

  async initMerge(page = 1) {
    const url = getUrl(API.get_list, { ...this.merge_from, current: page });
    const res: any = await this.$axios.get(url);
    this.table_data_merge = res.data.data ? res.data.data : [];
  }

  cancel() {
    this.show_add_tag = false;
  }

  submit() {
    console.log(2);
  }

  mergeNext() {
    if (this.merge_select_row_key.length > 1) {
      this.merge_dialog_type = enumMergeDialog.confirm_data;
    }
    console.log(this.merge_select_row_key);
  }

  mergeSubmit() {
    this.form_merge_company.validateFields(async (err: any, values: any) => {
      if (!err) {
        const send_data = {
          master_id: values.standard,
          slave_id_list: this.merge_select_row_key.filter((item) => item !== values.standard),
          full_name: values.full_name
        };
        const res: any = await this.$axios.post(API.post_merge, send_data);
        this.merge_dialog = false;
        this.init(this.table_data.current);
        console.log(values);
      }
    });
  }

  // mergeCancel() {
  //   this.merge_dialog = false;
  // }

  handleShowMergeDialog() {
    this.merge_select_row_data = [];
    this.merge_select_row_key = [];

    this.merge_dialog_type = enumMergeDialog.choose_company;
    this.merge_dialog = true;
    this.initMerge(1);
  }

  // mergeOnSelectChange(select_row_key: any, value: any) {
  //   this.merge_select_row_data = value;
  // }

  beforeCreate() {
    this.form_merge_company = this.$form.createForm(this);
    this.more_change_form = this.$form.createForm(this);
  }

  handleEdit(record: any) {
    this.is_edit = true;
    this.validate_map = {
      id: {
        value: record.id,
        status: '',
        help: ''
      },
      weixin_nickname: {
        value: record.weixin_nickname,
        status: '',
        help: ''
      },
      weixin_number: {
        value: record.weixin_number,
        status: '',
        help: ''
      },
      mobile: {
        value: record.mobile,
        status: '',
        help: ''
      },
      charge: {
        value: record.charge,
        status: '',
        help: ''
      },
      status: {
        value: record.status,
        status: '',
        help: ''
      }
    };
    this.follower_modal = true;
    console.log(record);
    // this.$router.push({
    //   path: '/hundun/company-detail',
    //   query: {id: record.id}
    // })
  }

  async confirmEdit() {
    let is_valid = true;
    if (!this.validate_map.weixin_nickname.value) {
      this.validate_map.weixin_nickname.status = 'error';
      this.validate_map.weixin_nickname.help = '请输入微信昵称';
      is_valid = false;
    }
    if (!this.validate_map.weixin_number.value) {
      this.validate_map.weixin_number.status = 'error';
      this.validate_map.weixin_number.help = '请输入微信号';
      is_valid = false;
    }
    if (this.validate_map.mobile.value) {
      const reg = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (!reg.test(this.validate_map.mobile.value)) {
        this.validate_map.mobile.status = 'error';
        this.validate_map.mobile.help = '请输入正确的手机号';
        return;
      }
    }
    if (!this.validate_map.charge.value) {
      this.validate_map.charge.status = 'error';
      this.validate_map.charge.help = '请输入负责人';
      is_valid = false;
    }
    if (!is_valid) {
      return;
    }
    const send_data = {
      weixin_nickname: this.validate_map.weixin_nickname.value,
      weixin_number: this.validate_map.weixin_number.value,
      mobile: this.validate_map.mobile.value,
      charge: this.validate_map.charge.value,
      status: this.validate_map.status.value
    };
    const res: any = this.is_edit ? await this.$axios.put(`${API.edit_follower}/${this.validate_map.id.value}`, send_data) : await this.$axios.post(API.edit_follower, send_data);
    if (res.data.status === 200) {
      this.$message.success(this.is_edit ? '编辑成功' : '新增成功');
    }
    if (res.data.status === 500) {
      this.$message.error(res.data.message);
      return;
    }
    this.init();
    this.follower_modal = false;
  }

  created() {
    this.init();
  }
}
